// extracted by mini-css-extract-plugin
module.exports = {"filtersGrid":"ProjectsDashboardPage_filtersGrid__3riGm"};